"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusAvatar = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
require("./StatusAvatar.scss");
var UserAvatar_1 = require("./UserAvatar");
var StatusAvatar = function (props) { return (react_1.default.createElement(UserAvatar_1.UserAvatar, { user: props.user, onClick: props.onClick, className: classnames_1.default('status-avatar', props.className) }, props.showCheckmark &&
    react_1.default.createElement("span", { className: "icon is-small" },
        react_1.default.createElement("i", { className: "fas fa-check fa-sm" })))); };
exports.StatusAvatar = StatusAvatar;
